<div class="whoo-page-container whoo-nav-bar-margin">
    <div class="header">
        <h1>{{ 'sorry-something-went-wrong' | transMigrated | async}}</h1>
    </div>
    <h2>{{ 'error-404-this-page-does-not-exist' | transMigrated | async}}</h2>
    <p> {{ 'attempted-url' | transMigrated | async}} <code>{{ attemptedUrl }}</code></p>

</div>
